function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7348 18.5265L16.5039 2.71432C16.2003 2.37911 15.7765 2.18936 15.3274 2.18936H5.84014C5.21714 2.18936 4.65106 2.5562 4.3949 3.12544C4.14191 3.69784 4.24627 4.36511 4.66371 4.82683L17.9428 19.5827L4.66371 34.3355C4.24627 34.8003 4.13875 35.4676 4.3949 36.0369C4.65106 36.6093 5.21714 36.9761 5.84014 36.9761H15.3274C15.7765 36.9761 16.2003 36.7832 16.5039 36.4543L30.7348 20.6421C31.2756 20.0413 31.2756 19.1242 30.7348 18.5265Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3654 14.4168L10.8072 0.463257C10.5393 0.167442 10.1653 0 9.76905 0H1.39692C0.847154 0 0.347617 0.323722 0.12157 0.82605C-0.101687 1.33117 -0.00959369 1.92001 0.35878 2.32745L12.077 15.3489L0.35878 28.3675C-0.00959369 28.7778 -0.104478 29.3666 0.12157 29.8689C0.347617 30.3741 0.847154 30.6978 1.39692 30.6978H9.76905C10.1653 30.6978 10.5393 30.5276 10.8072 30.2373L23.3654 16.2838C23.8426 15.7535 23.8426 14.9442 23.3654 14.4168Z",
  fill: "#055445",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 17.6988,
  y1: 2.18936,
  x2: 17.6988,
  y2: 36.9761,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF8031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8031",
  stopOpacity: 0
})));

function SvgRightArrowVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowVector);
export default __webpack_public_path__ + "static/media/rightArrowVector.0a04ab0af5de3b2244d0f5de4e4b6205.svg";
export { ForwardRef as ReactComponent };